import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }

  label {
    font-family: ${({ theme }) => theme.fonts.titleBold};
    font-size: 14px;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 8px;
  }

  input {
    width: 0;
    height: 0;
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }

  span {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.titleSemiBold};
    font-weight: bold;
    color: ${({ theme }) => theme.colors.danger};
    margin: 4px 0;
  }
`;

export const Preview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px #ddd dashed;
  padding: 8px;
  margin-bottom: 16px;
  width: max-content;
  align-self: center;
`;

export const FakeInput = styled.div`
  display: flex;
  width: 100%;
  height: 54px;
  border-radius: 5px;
  border: 1px #dedede solid;
  padding: 16px;
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.default};
  color: ${({ theme }) => theme.colors.black};
  position: relative;
`;

export const FakeButton = styled.button.attrs({
  type: "button",
})`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 14px;
  height: 54px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 0 5px 5px 0;
  width: max-content;
  padding: 0 16px;
  color: #fff;
  position: absolute;
  top: 0;
  right: 0;

  svg {
    margin-right: 8px;
  }
`;
